import * as core from '../../../../../../../core'
import * as proposalStatus from '../proposal-status'

export const RESOURCE = {
  payload: {
    description: '6. Closed Lost',
    enumId: core.dms.models.Enum.Id.from({
      partialId: proposalStatus.RESOURCE.payload.partialId,
    }),
    id: '6. Closed Lost',
    name: '6. Closed Lost',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
